var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import iconsData from './icons';
const StyledIcon = styled.svg `
  width: ${({ width }) => Number(width) + 'px'};
  height: ${({ height }) => Number(height) + 'px'};
`;
const getDefaults = (sprite) => {
    if (iconsData.hasOwnProperty(sprite)) {
        return iconsData[sprite];
    }
    return {};
};
export class Icon extends React.PureComponent {
    render() {
        const _a = this.props, { sprite, color, secondaryColor } = _a, props = __rest(_a, ["sprite", "color", "secondaryColor"]);
        const defaults = getDefaults(sprite);
        const color1 = color || defaults.primaryColor;
        const color2 = secondaryColor || defaults.secondaryColor;
        const useStroke = defaults.useStroke;
        return (React.createElement(StyledIcon, Object.assign({ xmlns: "http://www.w3.org/2000/svg" }, props),
            React.createElement("use", { xlinkHref: `#${sprite}`, fill: color1, stroke: useStroke ? color1 : undefined, color: color2 })));
    }
}
Icon.defaultProps = {
    width: 16,
    height: 16,
    sprite: 'icon-phone',
};
//# sourceMappingURL=index.js.map